import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const stabilityAi = defineConnector({
  identifier: "stabilityAi",
  name: "Stability AI",
  tagLine: "Generative AI platform",
  logo,
  protocol: "http",
  tags: ["ai", "engineering", "data"],
  defaultUrlPattern: () => "https://api\\.stability\\.ai/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Create an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Create or copy your API key from the [Stability AI platform docs and dashboard](https://platform.stability.ai/docs/getting-started/authentication). Stability uses `Authorization: Bearer <api_key>`.",
        },
      ],
    },
    {
      title: "Enter your Stability AI key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.stability.ai/v1/user/account",
  },
});
